// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #333333;
  --color-black: #000000;
  --color-light: #ffffff;
  --color-accent: #d4fb41;
  --color-accent-dark: #4c6b0d;
  --gray-900: #26282b;
  --gray-700: #525761;
  --gray-500: #8a8f98;
  --gray-300: #d8dade;
  --gray-200: #e6e7ea;
  --gray-100: #f3f4f6;
  --color-muted: #8a8f98;
  --color-border: #e6e7ea;
  --color-bg-light: #f3f4f6;
  --color-success: #219653;
  --color-danger: #e0554a;
  --color-warning: #f2c94c;
}

* {
  box-sizing: border-box;
  font-family: "Clans Pro", sans-serif;
}

html,
body,
#root {
  min-height: 100%;
  margin: 0;
  padding: 0;
}

body {
  background: var(--color-light);
  color: var(--color-primary);
  -webkit-font-smoothing: antialiased;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  cursor: pointer;
  outline: none;
  font-family: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--color-primary);
}

.btn-soft, .btn-outline, .btn-accent-solid, .btn-primary-solid {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  transition: background 0.15s ease, opacity 0.15s ease, border-color 0.15s ease;
}
.btn-soft:disabled, .btn-outline:disabled, .btn-accent-solid:disabled, .btn-primary-solid:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary-solid {
  background: var(--color-primary);
  color: var(--color-light);
  border: 1px solid var(--color-primary);
}
.btn-primary-solid:hover:not(:disabled) {
  background: #000;
  color: var(--color-light);
}

.btn-accent-solid {
  background: var(--color-accent);
  color: var(--color-black);
  border: 1px solid var(--color-accent);
}
.btn-accent-solid:hover:not(:disabled) {
  background: #c6ee2c;
  border-color: #c6ee2c;
  color: var(--color-black);
}

.btn-outline {
  background: var(--color-light);
  color: var(--gray-900);
  border: 1px solid var(--gray-300);
}
.btn-outline:hover:not(:disabled) {
  background: var(--gray-100);
  color: var(--gray-900);
}

.btn-soft {
  background: var(--gray-100);
  color: var(--gray-900);
  border: 1px solid transparent;
}
.btn-soft:hover:not(:disabled) {
  background: var(--gray-200);
}

.btn-outline-secondary {
  border-color: var(--gray-300) !important;
  color: var(--gray-900) !important;
  border-radius: 8px !important;
  font-weight: 500;
}
.btn-outline-secondary:hover {
  background: var(--gray-100) !important;
}

.btn-outline-danger,
.btn-danger {
  border-radius: 8px !important;
  font-weight: 500;
}

.link-accent {
  color: var(--color-accent-dark);
  font-weight: 700;
  font-size: 13px;
}
.link-accent:hover {
  color: var(--color-accent-dark);
  text-decoration: underline;
}

.card {
  background: var(--color-light);
  border-radius: 14px;
  border: 1px solid var(--gray-200);
  box-shadow: none;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-primary);
  margin: 0;
}

.text-muted {
  color: var(--gray-500) !important;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-700);
  margin-bottom: 6px;
}

.form-control,
.form-select {
  border-radius: 8px;
  border-color: var(--gray-300);
  font-size: 14px;
  padding: 9px 12px;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(212, 251, 65, 0.45);
}
.form-control:disabled,
.form-select:disabled {
  background: var(--gray-100);
}

.search-input {
  position: relative;
}
.search-input svg {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gray-500);
}
.search-input input {
  padding-left: 34px;
  background: var(--gray-100);
  border-color: transparent;
  min-width: 240px;
}

.nav-tabs {
  border-bottom: 1px solid var(--gray-200);
  gap: 4px;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
}
.nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  color: var(--gray-500);
  font-weight: 600;
  font-size: 14px;
  padding: 10px 16px;
  white-space: nowrap;
  background: transparent;
}
.nav-tabs .nav-link:hover {
  color: var(--color-primary);
  border-bottom-color: var(--gray-300);
}
.nav-tabs .nav-link.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
  background: transparent;
  font-weight: 700;
}

.segmented {
  display: inline-flex;
  background: #e9e9e9;
  border-radius: 8px;
  padding: 4px;
}
.segmented .segmented-btn {
  padding: 7px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  border: none;
  background: transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.segmented .segmented-btn:hover {
  color: #111;
}
.segmented .segmented-btn.active {
  background: #fff;
  color: var(--color-primary);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.table {
  --bs-table-hover-bg: var(--gray-100);
  margin-bottom: 0;
  font-size: 13.5px;
}
.table thead th {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--gray-500);
  border-bottom: 1px solid var(--color-primary);
  background: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
}
.table td {
  border-color: var(--gray-200);
  padding-top: 12px;
  padding-bottom: 12px;
}
.table tbody tr:last-child td {
  border-bottom: none;
}

.order-link {
  font-weight: 700;
  color: var(--color-primary);
}
.order-link:hover {
  color: var(--color-accent-dark);
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: var(--gray-100);
  color: var(--gray-700);
  white-space: nowrap;
}
.status-pill::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.status-pill.success {
  background: rgba(33, 150, 83, 0.1);
  color: var(--color-success);
}
.status-pill.danger {
  background: rgba(224, 85, 74, 0.1);
  color: var(--color-danger);
}
.status-pill.warning {
  background: rgba(242, 201, 76, 0.2);
  color: #8a6d00;
}
.status-pill.info {
  background: rgba(212, 251, 65, 0.35);
  color: var(--color-accent-dark);
}

.kv-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid var(--gray-100);
  font-size: 14px;
}
.kv-row:last-child {
  border-bottom: none;
}
.kv-row .kv-label {
  color: var(--gray-500);
}
.kv-row .kv-value {
  font-weight: 600;
  text-align: right;
}

.modal-content {
  border-radius: 14px;
  border: none;
}

.react-datepicker-wrapper {
  width: 100%;
}

.status-pill.no-dot::before {
  display: none;
}

.news-tile {
  display: flex;
  flex-direction: row;
  gap: 14px;
  padding: 16px;
  color: var(--color-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.news-tile:hover {
  border-color: var(--gray-300);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  color: var(--color-primary);
}
.news-tile .news-tile-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.news-tile .news-tile-title {
  font-weight: 700;
  font-size: 14.5px;
  line-height: 1.35;
}
.news-tile .news-tile-summary {
  font-size: 13px;
  color: var(--gray-700);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-tile .news-tile-meta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--gray-500);
  margin-top: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}
.page-header .page-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-500);
}
.page-header .page-back:hover {
  color: var(--color-primary);
}
.page-header .page-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}
.page-header .page-subtitle {
  color: var(--gray-500);
  font-size: 14px;
  margin-top: 4px;
}
.page-header .page-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.min-w-0 {
  min-width: 0;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
  border: 1px dashed var(--gray-300);
  border-radius: 14px;
}
.empty-state .empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--gray-100);
  color: var(--gray-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.notice {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 14px;
}
.notice.warning {
  background: #fff6dc;
  color: #6b5200;
}
.notice.info {
  background: rgba(212, 251, 65, 0.3);
  color: #34470a;
}
.notice.danger {
  background: rgba(224, 85, 74, 0.1);
  color: #8c2a22;
}

.icon-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: var(--gray-100);
  color: var(--color-primary);
}
.icon-inline:hover {
  background: var(--gray-200);
}

.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}
.timeline li {
  position: relative;
  display: flex;
  gap: 14px;
  padding-bottom: 18px;
}
.timeline li:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 16px;
  bottom: 0;
  border-left: 2px dashed var(--gray-300);
}
.timeline li:last-child {
  padding-bottom: 0;
}
.timeline .timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--gray-300);
  flex-shrink: 0;
  margin-top: 3px;
}
.timeline li.current .timeline-dot {
  background: var(--color-accent);
  box-shadow: 0 0 0 4px rgba(212, 251, 65, 0.35);
}

.bid-card {
  border: 1px solid var(--gray-200);
  border-radius: 12px;
  padding: 16px;
}
.bid-card.best {
  border-color: var(--color-accent-dark);
  box-shadow: 0 0 0 3px rgba(212, 251, 65, 0.35);
}
.bid-card .best-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--color-accent);
  border-radius: 4px;
  padding: 2px 6px;
  margin-bottom: 4px;
}

.stepper {
  display: flex;
  gap: 8px;
  max-width: 640px;
}
.stepper .stepper-step {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 3px solid var(--gray-200);
  font-size: 14px;
  font-weight: 600;
  color: var(--gray-500);
}
.stepper .stepper-step.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
.stepper .stepper-step.done {
  color: var(--color-primary);
  border-bottom-color: var(--color-accent-dark);
}
.stepper .stepper-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.stepper .active .stepper-num {
  background: var(--color-primary);
  color: #fff;
}
.stepper .done .stepper-num {
  background: var(--color-accent);
  color: #000;
}

.profile-photo {
  position: relative;
  flex-shrink: 0;
}
.profile-photo img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--gray-200);
}
.profile-photo .profile-photo-btn {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: var(--color-accent);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-top: 1px solid var(--gray-100);
  color: var(--color-primary);
}
.settings-link:first-child {
  border-top: none;
}
.settings-link:hover {
  background: #fafafa;
  color: var(--color-primary);
}
.settings-link .settings-link-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.settings-link .link-badge {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--color-danger);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.settings-link.logout {
  width: 100%;
  background: none;
  border: none;
  border-top: 1px solid var(--gray-100);
  color: var(--color-danger);
  text-align: left;
}

.notif-unread {
  background: rgba(212, 251, 65, 0.12);
  box-shadow: inset 3px 0 0 var(--color-accent-dark);
}

@keyframes modal-sheet-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  body {
    -webkit-tap-highlight-color: transparent;
  }
  .form-control,
  .form-select {
    font-size: 16px;
    padding: 11px 12px;
  }
  .btn-primary-solid, .btn-accent-solid, .btn-outline, .btn-soft {
    padding: 11px 16px;
    font-size: 15px;
  }
  .card.p-4 {
    padding: 16px !important;
  }
  .card.p-3 {
    padding: 14px !important;
  }
  .page-header {
    align-items: stretch;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .page-header .page-title {
    font-size: 21px;
  }
  .page-header .page-subtitle {
    font-size: 13px;
  }
  .page-header .page-actions {
    width: 100%;
  }
  .page-header .page-actions > * {
    flex: 1 1;
  }
  .section-title {
    font-size: 16px;
  }
  .nav-tabs {
    margin-left: -16px;
    margin-right: -16px;
    padding: 0 12px;
  }
  .nav-tabs .nav-link {
    padding: 10px 12px;
  }
  .card .nav-tabs {
    margin-left: 0;
    margin-right: 0;
  }
  .segmented {
    display: flex;
    width: 100%;
  }
  .segmented .segmented-btn {
    flex: 1 1;
    text-align: center;
    padding: 8px 10px;
  }
  .search-input {
    width: 100%;
  }
  .search-input input {
    min-width: 0;
    width: 100%;
  }
  .table-responsive {
    overflow: visible;
  }
  .card:has(> .table),
  .card:has(> .table-responsive) {
    border: none;
    background: transparent;
  }
  .table thead {
    display: none;
  }
  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
    width: 100%;
  }
  .table tbody tr {
    background: #fff;
    border: 1px solid var(--gray-200);
    border-radius: 14px;
    padding: 12px 14px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .table tbody tr:active {
    background: var(--gray-100);
  }
  .table td {
    display: block;
    padding: 5px 0 !important;
    border: none !important;
    text-align: right;
    font-size: 14px;
    overflow: hidden;
  }
  .table td::before {
    content: attr(data-label);
    float: left;
    margin-right: 12px;
    color: var(--gray-500);
    font-size: 12.5px;
    font-weight: 500;
    line-height: 1.7;
  }
  .table td[data-label=""]::before {
    display: none;
  }
  .table td:empty {
    display: none;
  }
  .table td:first-child {
    text-align: left;
    font-size: 15px;
    font-weight: 700;
    padding-bottom: 10px !important;
    margin-bottom: 4px;
    border-bottom: 1px solid var(--gray-100) !important;
  }
  .table td:first-child::before {
    display: none;
  }
  .modal.d-block {
    display: flex !important;
    align-items: flex-end;
  }
  .modal.d-block .modal-dialog {
    margin: 0;
    width: 100%;
    max-width: none;
    min-height: 0;
    align-items: flex-end;
  }
  .modal.d-block .modal-content {
    border-radius: 20px 20px 0 0;
    padding: 20px 16px calc(20px + env(safe-area-inset-bottom)) !important;
    max-height: 90vh;
    overflow-y: auto;
    animation: modal-sheet-up 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
  .modal.d-block .modal-content::before {
    content: "";
    display: block;
    width: 40px;
    height: 4px;
    border-radius: 4px;
    background: var(--gray-300);
    margin: -8px auto 16px;
  }
  .modal.d-block .modal-content .d-flex.justify-content-end {
    flex-direction: column-reverse;
  }
  .modal.d-block .modal-content .d-flex.justify-content-end > * {
    width: 100%;
  }
  .stepper .stepper-step {
    font-size: 13px;
  }
  .empty-state {
    padding: 36px 16px;
  }
}
.location-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/theme.scss"],"names":[],"mappings":"AAiBA;EACC,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;AAhBD;;AAmBA;EACC,sBAAA;EACA,oCAAA;AAhBD;;AAmBA;;;EAGC,gBAAA;EACA,SAAA;EACA,UAAA;AAhBD;;AAmBA;EACC,8BAAA;EACA,2BAAA;EACA,mCAAA;AAhBD;;AAmBA;EACC,qBAAA;EACA,cAAA;AAhBD;;AAmBA;EACC,eAAA;EACA,aAAA;EACA,oBAAA;AAhBD;;AAmBA;;;;;;EAMC,2BAAA;AAhBD;;AAoBA;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8EAAA;AAjBD;AAmBC;EACC,YAAA;EACA,mBAAA;AAjBF;;AAqBA;EAEC,gCAAA;EACA,yBAAA;EACA,sCAAA;AAnBD;AAqBC;EACC,gBAAA;EACA,yBAAA;AAnBF;;AAuBA;EAEC,+BAAA;EACA,yBAAA;EACA,qCAAA;AArBD;AAuBC;EACC,mBAAA;EACA,qBAAA;EACA,yBAAA;AArBF;;AAyBA;EAEC,8BAAA;EACA,sBAAA;EACA,iCAAA;AAvBD;AAyBC;EACC,2BAAA;EACA,sBAAA;AAvBF;;AA2BA;EAEC,2BAAA;EACA,sBAAA;EACA,6BAAA;AAzBD;AA2BC;EACC,2BAAA;AAzBF;;AA6BA;EACC,wCAAA;EACA,iCAAA;EACA,6BAAA;EACA,gBAAA;AA1BD;AA4BC;EACC,sCAAA;AA1BF;;AA8BA;;EAEC,6BAAA;EACA,gBAAA;AA3BD;;AA8BA;EACC,+BAAA;EACA,gBAAA;EACA,eAAA;AA3BD;AA6BC;EACC,+BAAA;EACA,0BAAA;AA3BF;;AAgCA;EACC,8BAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;AA7BD;;AAgCA;EACC,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;AA7BD;;AAgCA;EACC,iCAAA;AA7BD;;AAiCA;EACC,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AA9BD;;AAiCA;;EAEC,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AA9BD;AAgCC;;EACC,kCAAA;EACA,8CAAA;AA7BF;AAgCC;;EACC,2BAAA;AA7BF;;AAiCA;EACC,kBAAA;AA9BD;AAgCC;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;AA9BF;AAiCC;EACC,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AA/BF;;AAoCA;EACC,wCAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAjCD;AAmCC;EACC,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAjCF;AAmCE;EACC,2BAAA;EACA,oCAAA;AAjCH;AAoCE;EACC,2BAAA;EACA,yCAAA;EACA,uBAAA;EACA,gBAAA;AAlCH;;AAwCA;EACC,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AArCD;AAuCC;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AArCF;AAuCE;EACC,WAAA;AArCH;AAwCE;EACC,gBAAA;EACA,2BAAA;EACA,yCAAA;AAtCH;;AA4CA;EACC,oCAAA;EACA,gBAAA;EACA,iBAAA;AAzCD;AA2CC;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6CAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAzCF;AA4CC;EACC,6BAAA;EACA,iBAAA;EACA,oBAAA;AA1CF;AA6CC;EACC,mBAAA;AA3CF;;AA+CA;EACC,gBAAA;EACA,2BAAA;AA5CD;AA8CC;EACC,+BAAA;AA5CF;;AAiDA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;AA9CD;AAgDC;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AA9CF;AAiDC;EACC,kCAAA;EACA,2BAAA;AA/CF;AAiDC;EACC,kCAAA;EACA,0BAAA;AA/CF;AAiDC;EACC,mCAAA;EACA,cAAA;AA/CF;AAiDC;EACC,oCAAA;EACA,+BAAA;AA/CF;;AAoDA;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,wCAAA;EACA,eAAA;AAjDD;AAmDC;EACC,mBAAA;AAjDF;AAoDC;EACC,sBAAA;AAlDF;AAqDC;EACC,gBAAA;EACA,iBAAA;AAnDF;;AAwDA;EACC,mBAAA;EACA,YAAA;AArDD;;AAyDA;EACC,WAAA;AAtDD;;AAyDA;EACC,aAAA;AAtDD;;AA0DA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,0DAAA;AAvDD;AAyDC;EACC,6BAAA;EACA,0CAAA;EACA,2BAAA;AAvDF;AA0DC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAxDF;AA2DC;EACC,gBAAA;EACA,iBAAA;EACA,iBAAA;AAzDF;AA4DC;EACC,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA1DF;AA6DC;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA3DF;;AAgEA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA7DD;AA+DC;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA7DF;AA+DE;EACC,2BAAA;AA7DH;AAiEC;EACC,eAAA;EACA,gBAAA;EACA,SAAA;AA/DF;AAkEC;EACC,sBAAA;EACA,eAAA;EACA,eAAA;AAhEF;AAmEC;EACC,aAAA;EACA,QAAA;EACA,eAAA;AAjEF;;AAqEA;EACC,YAAA;AAlED;;AAqEA;EACC,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAlED;AAoEC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAlEF;;AAuEA;EACC,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AApED;AAsEC;EACC,mBAAA;EACA,cAAA;AApEF;AAsEC;EACC,mCAAA;EACA,cAAA;AApEF;AAsEC;EACC,kCAAA;EACA,cAAA;AApEF;;AAwEA;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,2BAAA;AArED;AAuEC;EACC,2BAAA;AArEF;;AA0EA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAvED;AAyEC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;AAvEF;AAyEE;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,uCAAA;AAvEH;AA0EE;EACC,iBAAA;AAxEH;AA4EC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AA1EF;AA6EC;EACC,+BAAA;EACA,8CAAA;AA3EF;;AAgFA;EACC,iCAAA;EACA,mBAAA;EACA,aAAA;AA7ED;AA+EC;EACC,sCAAA;EACA,8CAAA;AA7EF;AAgFC;EACC,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA9EF;;AAmFA;EACC,aAAA;EACA,QAAA;EACA,gBAAA;AAhFD;AAkFC;EACC,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAhFF;AAkFE;EACC,2BAAA;EACA,yCAAA;AAhFH;AAmFE;EACC,2BAAA;EACA,6CAAA;AAjFH;AAqFC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAnFF;AAsFC;EACC,gCAAA;EACA,WAAA;AApFF;AAuFC;EACC,+BAAA;EACA,WAAA;AArFF;;AA0FA;EACC,kBAAA;EACA,cAAA;AAvFD;AAyFC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AAvFF;AA0FC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxFF;;AA4FA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;AAzFD;AA2FC;EACC,gBAAA;AAzFF;AA4FC;EACC,mBAAA;EACA,2BAAA;AA1FF;AA6FC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA3FF;AA8FC;EACC,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA5FF;AA+FC;EACC,WAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,0BAAA;EACA,gBAAA;AA7FF;;AAiGA;EACC,oCAAA;EACA,kDAAA;AA9FD;;AAoGA;EACC;IACC,2BAAA;EAjGA;EAmGD;IACC,wBAAA;EAjGA;AACF;AAoGA;EACC;IACC,wCAAA;EAlGA;EAsGD;;IAEC,eAAA;IACA,kBAAA;EApGA;EAuGD;IACC,kBAAA;IACA,eAAA;EArGA;EAwGD;IACC,wBAAA;EAtGA;EAyGD;IACC,wBAAA;EAvGA;EA2GD;IACC,oBAAA;IACA,sBAAA;IACA,mBAAA;EAzGA;EA2GA;IACC,eAAA;EAzGD;EA4GA;IACC,eAAA;EA1GD;EA6GA;IACC,WAAA;EA3GD;EA6GC;IACC,SAAA;EA3GF;EAgHD;IACC,eAAA;EA9GA;EAkHD;IACC,kBAAA;IACA,mBAAA;IACA,eAAA;EAhHA;EAkHA;IACC,kBAAA;EAhHD;EAoHD;IACC,cAAA;IACA,eAAA;EAlHA;EAqHD;IACC,aAAA;IACA,WAAA;EAnHA;EAqHA;IACC,SAAA;IACA,kBAAA;IACA,iBAAA;EAnHD;EAuHD;IACC,WAAA;EArHA;EAuHA;IACC,YAAA;IACA,WAAA;EArHD;EA0HD;IACC,iBAAA;EAxHA;EA2HD;;IAEC,YAAA;IACA,uBAAA;EAzHA;EA6HA;IACC,aAAA;EA3HD;EA8HA;;;;IAIC,cAAA;IACA,WAAA;EA5HD;EA+HA;IACC,gBAAA;IACA,iCAAA;IACA,mBAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;EA7HD;EA+HC;IACC,2BAAA;EA7HF;EAiIA;IACC,cAAA;IACA,yBAAA;IACA,uBAAA;IACA,iBAAA;IACA,eAAA;IACA,gBAAA;EA/HD;EAkIC;IACC,yBAAA;IACA,WAAA;IACA,kBAAA;IACA,sBAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAhIF;EAmIC;IACC,aAAA;EAjIF;EAoIC;IACC,aAAA;EAlIF;EAqIC;IACC,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,+BAAA;IACA,kBAAA;IACA,mDAAA;EAnIF;EAqIE;IACC,aAAA;EAnIH;EA0ID;IACC,wBAAA;IACA,qBAAA;EAxIA;EA0IA;IACC,SAAA;IACA,WAAA;IACA,eAAA;IACA,aAAA;IACA,qBAAA;EAxID;EA2IA;IACC,4BAAA;IACA,sEAAA;IACA,gBAAA;IACA,gBAAA;IACA,8DAAA;EAzID;EA2IC;IACC,WAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,2BAAA;IACA,sBAAA;EAzIF;EA4IC;IACC,8BAAA;EA1IF;EA4IE;IACC,WAAA;EA1IH;EAiJA;IACC,eAAA;EA/ID;EAmJD;IACC,kBAAA;EAjJA;AACF;AAoJA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAlJD","sourcesContent":["// Palette mirrors ordrx_frontend's \"Seller Central visual refresh\"\n// (src/_App.variables.scss) so Buyer Central and Seller Central read as one product.\n$color-primary: #333333;\n$color-black: #000000;\n$color-light: #ffffff;\n$color-accent: #d4fb41; // chartreuse CTA\n$color-accent-dark: #4c6b0d; // readable accent for text/icons on white\n$color-gray-900: #26282b;\n$color-gray-700: #525761;\n$color-gray-500: #8a8f98;\n$color-gray-300: #d8dade;\n$color-gray-200: #e6e7ea;\n$color-gray-100: #f3f4f6;\n$color-success: #219653;\n$color-danger: #e0554a;\n$color-warning: #f2c94c;\n\n:root {\n\t--color-primary: #{$color-primary};\n\t--color-black: #{$color-black};\n\t--color-light: #{$color-light};\n\t--color-accent: #{$color-accent};\n\t--color-accent-dark: #{$color-accent-dark};\n\t--gray-900: #{$color-gray-900};\n\t--gray-700: #{$color-gray-700};\n\t--gray-500: #{$color-gray-500};\n\t--gray-300: #{$color-gray-300};\n\t--gray-200: #{$color-gray-200};\n\t--gray-100: #{$color-gray-100};\n\t--color-muted: #{$color-gray-500};\n\t--color-border: #{$color-gray-200};\n\t--color-bg-light: #{$color-gray-100};\n\t--color-success: #{$color-success};\n\t--color-danger: #{$color-danger};\n\t--color-warning: #{$color-warning};\n}\n\n* {\n\tbox-sizing: border-box;\n\tfont-family: \"Clans Pro\", sans-serif;\n}\n\nhtml,\nbody,\n#root {\n\tmin-height: 100%;\n\tmargin: 0;\n\tpadding: 0;\n}\n\nbody {\n\tbackground: var(--color-light);\n\tcolor: var(--color-primary);\n\t-webkit-font-smoothing: antialiased;\n}\n\na {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\nbutton {\n\tcursor: pointer;\n\toutline: none;\n\tfont-family: inherit;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tcolor: var(--color-primary);\n}\n\n// ---------- Buttons ----------\n%btn-base {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 6px;\n\tborder-radius: 8px;\n\tpadding: 9px 18px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tline-height: 1.3;\n\twhite-space: nowrap;\n\ttransition: background 0.15s ease, opacity 0.15s ease, border-color 0.15s ease;\n\n\t&:disabled {\n\t\topacity: 0.5;\n\t\tcursor: not-allowed;\n\t}\n}\n\n.btn-primary-solid {\n\t@extend %btn-base;\n\tbackground: var(--color-primary);\n\tcolor: var(--color-light);\n\tborder: 1px solid var(--color-primary);\n\n\t&:hover:not(:disabled) {\n\t\tbackground: #000;\n\t\tcolor: var(--color-light);\n\t}\n}\n\n.btn-accent-solid {\n\t@extend %btn-base;\n\tbackground: var(--color-accent);\n\tcolor: var(--color-black);\n\tborder: 1px solid var(--color-accent);\n\n\t&:hover:not(:disabled) {\n\t\tbackground: #c6ee2c;\n\t\tborder-color: #c6ee2c;\n\t\tcolor: var(--color-black);\n\t}\n}\n\n.btn-outline {\n\t@extend %btn-base;\n\tbackground: var(--color-light);\n\tcolor: var(--gray-900);\n\tborder: 1px solid var(--gray-300);\n\n\t&:hover:not(:disabled) {\n\t\tbackground: var(--gray-100);\n\t\tcolor: var(--gray-900);\n\t}\n}\n\n.btn-soft {\n\t@extend %btn-base;\n\tbackground: var(--gray-100);\n\tcolor: var(--gray-900);\n\tborder: 1px solid transparent;\n\n\t&:hover:not(:disabled) {\n\t\tbackground: var(--gray-200);\n\t}\n}\n\n.btn-outline-secondary {\n\tborder-color: var(--gray-300) !important;\n\tcolor: var(--gray-900) !important;\n\tborder-radius: 8px !important;\n\tfont-weight: 500;\n\n\t&:hover {\n\t\tbackground: var(--gray-100) !important;\n\t}\n}\n\n.btn-outline-danger,\n.btn-danger {\n\tborder-radius: 8px !important;\n\tfont-weight: 500;\n}\n\n.link-accent {\n\tcolor: var(--color-accent-dark);\n\tfont-weight: 700;\n\tfont-size: 13px;\n\n\t&:hover {\n\t\tcolor: var(--color-accent-dark);\n\t\ttext-decoration: underline;\n\t}\n}\n\n// ---------- Surfaces ----------\n.card {\n\tbackground: var(--color-light);\n\tborder-radius: 14px;\n\tborder: 1px solid var(--gray-200);\n\tbox-shadow: none;\n}\n\n.section-title {\n\tfont-size: 15px;\n\tfont-weight: 700;\n\tcolor: var(--color-primary);\n\tmargin: 0;\n}\n\n.text-muted {\n\tcolor: var(--gray-500) !important;\n}\n\n// ---------- Forms ----------\n.form-label {\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: var(--gray-700);\n\tmargin-bottom: 6px;\n}\n\n.form-control,\n.form-select {\n\tborder-radius: 8px;\n\tborder-color: var(--gray-300);\n\tfont-size: 14px;\n\tpadding: 9px 12px;\n\n\t&:focus {\n\t\tborder-color: var(--color-primary);\n\t\tbox-shadow: 0 0 0 3px rgba(212, 251, 65, 0.45);\n\t}\n\n\t&:disabled {\n\t\tbackground: var(--gray-100);\n\t}\n}\n\n.search-input {\n\tposition: relative;\n\n\tsvg {\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tcolor: var(--gray-500);\n\t}\n\n\tinput {\n\t\tpadding-left: 34px;\n\t\tbackground: var(--gray-100);\n\t\tborder-color: transparent;\n\t\tmin-width: 240px;\n\t}\n}\n\n// ---------- Tabs (Seller Central tab bar) ----------\n.nav-tabs {\n\tborder-bottom: 1px solid var(--gray-200);\n\tgap: 4px;\n\tflex-wrap: nowrap;\n\toverflow-x: auto;\n\tscrollbar-width: none;\n\n\t.nav-link {\n\t\tborder: none;\n\t\tborder-bottom: 3px solid transparent;\n\t\tborder-radius: 0;\n\t\tcolor: var(--gray-500);\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tpadding: 10px 16px;\n\t\twhite-space: nowrap;\n\t\tbackground: transparent;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary);\n\t\t\tborder-bottom-color: var(--gray-300);\n\t\t}\n\n\t\t&.active {\n\t\t\tcolor: var(--color-primary);\n\t\t\tborder-bottom-color: var(--color-primary);\n\t\t\tbackground: transparent;\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n}\n\n// Segmented switcher (Open Market / Closed Market)\n.segmented {\n\tdisplay: inline-flex;\n\tbackground: #e9e9e9;\n\tborder-radius: 8px;\n\tpadding: 4px;\n\n\t.segmented-btn {\n\t\tpadding: 7px 18px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: #555;\n\t\tborder: none;\n\t\tbackground: transparent;\n\t\tborder-radius: 6px;\n\t\ttransition: all 0.2s ease;\n\n\t\t&:hover {\n\t\t\tcolor: #111;\n\t\t}\n\n\t\t&.active {\n\t\t\tbackground: #fff;\n\t\t\tcolor: var(--color-primary);\n\t\t\tbox-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n\t\t}\n\t}\n}\n\n// ---------- Tables ----------\n.table {\n\t--bs-table-hover-bg: var(--gray-100);\n\tmargin-bottom: 0;\n\tfont-size: 13.5px;\n\n\tthead th {\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.03em;\n\t\tcolor: var(--gray-500);\n\t\tborder-bottom: 1px solid var(--color-primary);\n\t\tbackground: transparent;\n\t\tpadding-top: 12px;\n\t\tpadding-bottom: 12px;\n\t}\n\n\ttd {\n\t\tborder-color: var(--gray-200);\n\t\tpadding-top: 12px;\n\t\tpadding-bottom: 12px;\n\t}\n\n\ttbody tr:last-child td {\n\t\tborder-bottom: none;\n\t}\n}\n\n.order-link {\n\tfont-weight: 700;\n\tcolor: var(--color-primary);\n\n\t&:hover {\n\t\tcolor: var(--color-accent-dark);\n\t}\n}\n\n// ---------- Status pills ----------\n.status-pill {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 4px 10px;\n\tborder-radius: 20px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tbackground: var(--gray-100);\n\tcolor: var(--gray-700);\n\twhite-space: nowrap;\n\n\t&::before {\n\t\tcontent: \"\";\n\t\twidth: 6px;\n\t\theight: 6px;\n\t\tborder-radius: 50%;\n\t\tbackground: currentColor;\n\t}\n\n\t&.success {\n\t\tbackground: rgba(33, 150, 83, 0.1);\n\t\tcolor: var(--color-success);\n\t}\n\t&.danger {\n\t\tbackground: rgba(224, 85, 74, 0.1);\n\t\tcolor: var(--color-danger);\n\t}\n\t&.warning {\n\t\tbackground: rgba(242, 201, 76, 0.2);\n\t\tcolor: #8a6d00;\n\t}\n\t&.info {\n\t\tbackground: rgba(212, 251, 65, 0.35);\n\t\tcolor: var(--color-accent-dark);\n\t}\n}\n\n// ---------- Key/value rows ----------\n.kv-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 16px;\n\tpadding: 10px 0;\n\tborder-bottom: 1px solid var(--gray-100);\n\tfont-size: 14px;\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n\n\t.kv-label {\n\t\tcolor: var(--gray-500);\n\t}\n\n\t.kv-value {\n\t\tfont-weight: 600;\n\t\ttext-align: right;\n\t}\n}\n\n// ---------- Modals ----------\n.modal-content {\n\tborder-radius: 14px;\n\tborder: none;\n}\n\n// ---------- react-datepicker ----------\n.react-datepicker-wrapper {\n\twidth: 100%;\n}\n\n.status-pill.no-dot::before {\n\tdisplay: none;\n}\n\n// ---------- News tiles (Market updates) ----------\n.news-tile {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 14px;\n\tpadding: 16px;\n\tcolor: var(--color-primary);\n\ttransition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n\t&:hover {\n\t\tborder-color: var(--gray-300);\n\t\tbox-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.news-tile-body {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 6px;\n\t\tmin-width: 0;\n\t}\n\n\t.news-tile-title {\n\t\tfont-weight: 700;\n\t\tfont-size: 14.5px;\n\t\tline-height: 1.35;\n\t}\n\n\t.news-tile-summary {\n\t\tfont-size: 13px;\n\t\tcolor: var(--gray-700);\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t}\n\n\t.news-tile-meta {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tfont-size: 12px;\n\t\tcolor: var(--gray-500);\n\t\tmargin-top: auto;\n\t}\n}\n\n// ---------- Page header / empty state ----------\n.page-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-end;\n\tflex-wrap: wrap;\n\tgap: 12px;\n\tmargin-bottom: 20px;\n\n\t.page-back {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tbackground: none;\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tmargin-bottom: 6px;\n\t\tfont-size: 13px;\n\t\tfont-weight: 600;\n\t\tcolor: var(--gray-500);\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t.page-title {\n\t\tfont-size: 24px;\n\t\tfont-weight: 700;\n\t\tmargin: 0;\n\t}\n\n\t.page-subtitle {\n\t\tcolor: var(--gray-500);\n\t\tfont-size: 14px;\n\t\tmargin-top: 4px;\n\t}\n\n\t.page-actions {\n\t\tdisplay: flex;\n\t\tgap: 8px;\n\t\tflex-wrap: wrap;\n\t}\n}\n\n.min-w-0 {\n\tmin-width: 0;\n}\n\n.empty-state {\n\ttext-align: center;\n\tpadding: 48px 16px;\n\tborder: 1px dashed var(--gray-300);\n\tborder-radius: 14px;\n\n\t.empty-icon {\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tborder-radius: 12px;\n\t\tbackground: var(--gray-100);\n\t\tcolor: var(--gray-700);\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 12px;\n\t}\n}\n\n// ---------- Notices ----------\n.notice {\n\tdisplay: flex;\n\tgap: 12px;\n\talign-items: flex-start;\n\tpadding: 14px 16px;\n\tborder-radius: 12px;\n\tfont-size: 14px;\n\n\t&.warning {\n\t\tbackground: #fff6dc;\n\t\tcolor: #6b5200;\n\t}\n\t&.info {\n\t\tbackground: rgba(212, 251, 65, 0.3);\n\t\tcolor: #34470a;\n\t}\n\t&.danger {\n\t\tbackground: rgba(224, 85, 74, 0.1);\n\t\tcolor: #8c2a22;\n\t}\n}\n\n.icon-inline {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 26px;\n\theight: 26px;\n\tborder-radius: 6px;\n\tborder: none;\n\tbackground: var(--gray-100);\n\tcolor: var(--color-primary);\n\n\t&:hover {\n\t\tbackground: var(--gray-200);\n\t}\n}\n\n// ---------- Order tracking timeline ----------\n.timeline {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\n\tli {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tgap: 14px;\n\t\tpadding-bottom: 18px;\n\n\t\t&:not(:last-child)::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 6px;\n\t\t\ttop: 16px;\n\t\t\tbottom: 0;\n\t\t\tborder-left: 2px dashed var(--gray-300);\n\t\t}\n\n\t\t&:last-child {\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t}\n\n\t.timeline-dot {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t\tborder-radius: 50%;\n\t\tbackground: var(--gray-300);\n\t\tflex-shrink: 0;\n\t\tmargin-top: 3px;\n\t}\n\n\tli.current .timeline-dot {\n\t\tbackground: var(--color-accent);\n\t\tbox-shadow: 0 0 0 4px rgba(212, 251, 65, 0.35);\n\t}\n}\n\n// ---------- Bid cards ----------\n.bid-card {\n\tborder: 1px solid var(--gray-200);\n\tborder-radius: 12px;\n\tpadding: 16px;\n\n\t&.best {\n\t\tborder-color: var(--color-accent-dark);\n\t\tbox-shadow: 0 0 0 3px rgba(212, 251, 65, 0.35);\n\t}\n\n\t.best-tag {\n\t\tdisplay: inline-block;\n\t\tfont-size: 11px;\n\t\tfont-weight: 700;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.04em;\n\t\tbackground: var(--color-accent);\n\t\tborder-radius: 4px;\n\t\tpadding: 2px 6px;\n\t\tmargin-bottom: 4px;\n\t}\n}\n\n// ---------- Stepper ----------\n.stepper {\n\tdisplay: flex;\n\tgap: 8px;\n\tmax-width: 640px;\n\n\t.stepper-step {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tpadding-bottom: 10px;\n\t\tborder-bottom: 3px solid var(--gray-200);\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: var(--gray-500);\n\n\t\t&.active {\n\t\t\tcolor: var(--color-primary);\n\t\t\tborder-bottom-color: var(--color-primary);\n\t\t}\n\n\t\t&.done {\n\t\t\tcolor: var(--color-primary);\n\t\t\tborder-bottom-color: var(--color-accent-dark);\n\t\t}\n\t}\n\n\t.stepper-num {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground: var(--gray-100);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-size: 12px;\n\t}\n\n\t.active .stepper-num {\n\t\tbackground: var(--color-primary);\n\t\tcolor: #fff;\n\t}\n\n\t.done .stepper-num {\n\t\tbackground: var(--color-accent);\n\t\tcolor: #000;\n\t}\n}\n\n// ---------- Settings ----------\n.profile-photo {\n\tposition: relative;\n\tflex-shrink: 0;\n\n\timg {\n\t\twidth: 72px;\n\t\theight: 72px;\n\t\tborder-radius: 50%;\n\t\tobject-fit: cover;\n\t\tborder: 1px solid var(--gray-200);\n\t}\n\n\t.profile-photo-btn {\n\t\tposition: absolute;\n\t\tright: -2px;\n\t\tbottom: -2px;\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t\tborder: 2px solid #fff;\n\t\tbackground: var(--color-accent);\n\t\tcolor: #000;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n\n.settings-link {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding: 14px 18px;\n\tborder-top: 1px solid var(--gray-100);\n\tcolor: var(--color-primary);\n\n\t&:first-child {\n\t\tborder-top: none;\n\t}\n\n\t&:hover {\n\t\tbackground: #fafafa;\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.settings-link-icon {\n\t\twidth: 36px;\n\t\theight: 36px;\n\t\tborder-radius: 9px;\n\t\tbackground: var(--gray-100);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.link-badge {\n\t\tmin-width: 20px;\n\t\theight: 20px;\n\t\tpadding: 0 6px;\n\t\tborder-radius: 10px;\n\t\tbackground: var(--color-danger);\n\t\tcolor: #fff;\n\t\tfont-size: 11px;\n\t\tfont-weight: 700;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t&.logout {\n\t\twidth: 100%;\n\t\tbackground: none;\n\t\tborder: none;\n\t\tborder-top: 1px solid var(--gray-100);\n\t\tcolor: var(--color-danger);\n\t\ttext-align: left;\n\t}\n}\n\n.notif-unread {\n\tbackground: rgba(212, 251, 65, 0.12);\n\tbox-shadow: inset 3px 0 0 var(--color-accent-dark);\n}\n\n// =====================================================================\n// Phone (≤768px): app-like presentation\n// =====================================================================\n@keyframes modal-sheet-up {\n\tfrom {\n\t\ttransform: translateY(100%);\n\t}\n\tto {\n\t\ttransform: translateY(0);\n\t}\n}\n\n@media (max-width: 768px) {\n\tbody {\n\t\t-webkit-tap-highlight-color: transparent;\n\t}\n\n\t// iOS zooms into inputs under 16px\n\t.form-control,\n\t.form-select {\n\t\tfont-size: 16px;\n\t\tpadding: 11px 12px;\n\t}\n\n\t%btn-base {\n\t\tpadding: 11px 16px;\n\t\tfont-size: 15px;\n\t}\n\n\t.card.p-4 {\n\t\tpadding: 16px !important;\n\t}\n\n\t.card.p-3 {\n\t\tpadding: 14px !important;\n\t}\n\n\t// ---- Page header ----\n\t.page-header {\n\t\talign-items: stretch;\n\t\tflex-direction: column;\n\t\tmargin-bottom: 16px;\n\n\t\t.page-title {\n\t\t\tfont-size: 21px;\n\t\t}\n\n\t\t.page-subtitle {\n\t\t\tfont-size: 13px;\n\t\t}\n\n\t\t.page-actions {\n\t\t\twidth: 100%;\n\n\t\t\t> * {\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t.section-title {\n\t\tfont-size: 16px;\n\t}\n\n\t// ---- Tabs scroll sideways like a native segmented tab strip ----\n\t.nav-tabs {\n\t\tmargin-left: -16px;\n\t\tmargin-right: -16px;\n\t\tpadding: 0 12px;\n\n\t\t.nav-link {\n\t\t\tpadding: 10px 12px;\n\t\t}\n\t}\n\n\t.card .nav-tabs {\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t}\n\n\t.segmented {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\n\t\t.segmented-btn {\n\t\t\tflex: 1;\n\t\t\ttext-align: center;\n\t\t\tpadding: 8px 10px;\n\t\t}\n\t}\n\n\t.search-input {\n\t\twidth: 100%;\n\n\t\tinput {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t// ---- Tables become stacked cards (labels via useTableCardLabels) ----\n\t.table-responsive {\n\t\toverflow: visible;\n\t}\n\n\t.card:has(> .table),\n\t.card:has(> .table-responsive) {\n\t\tborder: none;\n\t\tbackground: transparent;\n\t}\n\n\t.table {\n\t\tthead {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&,\n\t\ttbody,\n\t\ttr,\n\t\ttd {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\ttbody tr {\n\t\t\tbackground: #fff;\n\t\t\tborder: 1px solid var(--gray-200);\n\t\t\tborder-radius: 14px;\n\t\t\tpadding: 12px 14px;\n\t\t\tmargin-bottom: 10px;\n\t\t\tcursor: pointer;\n\n\t\t\t&:active {\n\t\t\t\tbackground: var(--gray-100);\n\t\t\t}\n\t\t}\n\n\t\ttd {\n\t\t\tdisplay: block;\n\t\t\tpadding: 5px 0 !important;\n\t\t\tborder: none !important;\n\t\t\ttext-align: right;\n\t\t\tfont-size: 14px;\n\t\t\toverflow: hidden;\n\n\t\t\t// label floats left, the value (however many inline pieces) flows right\n\t\t\t&::before {\n\t\t\t\tcontent: attr(data-label);\n\t\t\t\tfloat: left;\n\t\t\t\tmargin-right: 12px;\n\t\t\t\tcolor: var(--gray-500);\n\t\t\t\tfont-size: 12.5px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 1.7;\n\t\t\t}\n\n\t\t\t&[data-label=\"\"]::before {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t&:empty {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t&:first-child {\n\t\t\t\ttext-align: left;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tpadding-bottom: 10px !important;\n\t\t\t\tmargin-bottom: 4px;\n\t\t\t\tborder-bottom: 1px solid var(--gray-100) !important;\n\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// ---- Modals open as bottom sheets ----\n\t.modal.d-block {\n\t\tdisplay: flex !important;\n\t\talign-items: flex-end;\n\n\t\t.modal-dialog {\n\t\t\tmargin: 0;\n\t\t\twidth: 100%;\n\t\t\tmax-width: none;\n\t\t\tmin-height: 0;\n\t\t\talign-items: flex-end;\n\t\t}\n\n\t\t.modal-content {\n\t\t\tborder-radius: 20px 20px 0 0;\n\t\t\tpadding: 20px 16px calc(20px + env(safe-area-inset-bottom)) !important;\n\t\t\tmax-height: 90vh;\n\t\t\toverflow-y: auto;\n\t\t\tanimation: modal-sheet-up 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);\n\n\t\t\t&::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 4px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tbackground: var(--gray-300);\n\t\t\t\tmargin: -8px auto 16px;\n\t\t\t}\n\n\t\t\t.d-flex.justify-content-end {\n\t\t\t\tflex-direction: column-reverse;\n\n\t\t\t\t> * {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.stepper {\n\t\t.stepper-step {\n\t\t\tfont-size: 13px;\n\t\t}\n\t}\n\n\t.empty-state {\n\t\tpadding: 36px 16px;\n\t}\n}\n\n.location-card-icon {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 10px;\n\tbackground: var(--gray-100);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
